export const SUPPORTED_LOCALES = ["zh-CN", "en"] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: Locale = "zh-CN";
export const LOCALE_STORAGE_KEY = "xiuxian.runtime.locale";

export interface LocaleStorageLike {
  getItem: (key: string) => string | null;
  setItem: (key: string, value: string) => void;
  removeItem?: (key: string) => void;
}

export type TranslationParams = Readonly<
  Record<string, string | number | boolean>
>;

export type TranslationTree = {
  readonly [key: string]: string | TranslationTree;
};
